@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.errorText {
  @include ui-sm-text;
  color: var(--negative-50);

  [data-autopilot-system-redesign='on'] & {
    @include sm-sohne;
    color: var(--red-70);
  }
}

.errorMessage {
  display: flex;
  text-align: center;
  align-items: flex-start;
  margin: 12px 10px;
}

.alertIcon {
  fill: var(--negative-50);
  margin-right: 7px;

  [data-autopilot-system-redesign='on'] & {
    fill: var(--red-70);
  }

  svg {
    overflow: visible;
    align-self: flex-start;
  }
}
